/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateMissingReferredProjectDeliverable200Response
 */
export interface CreateMissingReferredProjectDeliverable200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateMissingReferredProjectDeliverable200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the CreateMissingReferredProjectDeliverable200Response interface.
 */
export function instanceOfCreateMissingReferredProjectDeliverable200Response(value: object): value is CreateMissingReferredProjectDeliverable200Response {
    return true;
}

export function CreateMissingReferredProjectDeliverable200ResponseFromJSON(json: any): CreateMissingReferredProjectDeliverable200Response {
    return CreateMissingReferredProjectDeliverable200ResponseFromJSONTyped(json, false);
}

export function CreateMissingReferredProjectDeliverable200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMissingReferredProjectDeliverable200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function CreateMissingReferredProjectDeliverable200ResponseToJSON(value?: CreateMissingReferredProjectDeliverable200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
    };
}

